import { base } from "./base";
import { emartmall } from "./emartmall";

export const ROUTE_API = {
  ...base,
  emartmall: emartmall,
};
export default ROUTE_API;
